<div class="support-ticket-container">
  <div class="flex-box">
    <div class="heading">Support tickets</div>
    <a routerLink="/chats/open-tickets/new" [queryParams]="{ userId: user?.id }" target="_blank" class="icon pointer" data-testid="sales-new-ticket">
      <img src="/assets/images/add.svg" alt="Add">
    </a>
  </div>
  <div style="max-height: 120px; overflow-y: scroll;" >
    <ng-container *ngFor="let ticket of tickets">
      <div class="support-ticket-cell-container bdr-btm">
        <div class="flex-box pointer" (click)="redirectToTicketPage(ticket)">
          <div class="date flex justifySA col-xs-3">{{ticket.get("createdAt") | amDateFormat: 'DD MMM YY'}}</div>
          <div class="title col-xs-6">{{ticket.get('ticketNumber')}} : {{ticket.get('title') ||
            ticket.get('titleLanguageString')?.get('en')}}</div>
          <div class="concern-txt col-xs-3">{{ticket.get("closedAt") | amDateFormat: 'DD MMM YY'}}</div>
        </div>
      </div>
    </ng-container>
  </div>
</div>